import React, { useState } from 'react';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Close, Typography } from '@HomaHealth/ui-component-library';
import { Autocomplete } from '@mui/material';
import {
  Chip,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Checkbox, Grid, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { getTextWithToolTip } from '../../../core-utils/helper-utils/riskPatientDetailsHelper';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import ListBox from '../ListBox';
export interface AutocompleteWithCheckBoxesProps {
  options: any[];
   
  handleChange: (event: any, value: any, reason: any, details: any) => any;
  placeholder?: string;
  defaultValue?: any[];
  width?: string;
   
  onOpen?: ((event: React.ChangeEvent<{}>) => void) | undefined;
   
  onScrollEvent?: (event: React.SyntheticEvent) => void;
   
  getOptionLabel?: ((option: any) => string) | undefined;
  popupIcon?: any;
  disabled?: boolean;
  typable?: boolean;
  limitTags?: number;
  noOptionsText?: string;
  height?: string;
  disableClearAll?: boolean;
  renderOption?: any;
  dropdownWidth?: string;
  fullWidthText?: boolean;
  label?: string;
}

const useStyles = makeStyles<{
  hasSelection?: boolean;
  dropdownWidth?: string;
  width?: string;
}>()((theme, { hasSelection, dropdownWidth, width }) => ({
  //autocomplete
  autoCompleteDropdown: {
    '&  > .MuiInputBase-root': {
      height: '36px',
      width: '301px',
      border: 'none',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: '4px 0px 4px 8px',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      padding: '0px',
      paddingLeft: '4px',
    },
    '&. MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"] .MuiAutocomplete-input': {
      padding: '0px',
      paddingLeft: '4px',
    },
  },
  autoCompleteInput: {
    border: 'none',
    backgroundColor: patientAccessTheme.palette.status.white,
    '& .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    },
    '& input': {
      fontSize: '14px',
      lineHeight: '24px',
      color: patientAccessTheme.palette.text.mediumemphasis,
      fontWeight: 500,
    },
    '& input::placeholder': {
      fontSize: '14px',
      lineHeight: '24px',
      color: patientAccessTheme.palette.text.mediumemphasis,
      fontWeight: 500,
    },
    '& .MuiAutocomplete-input': {
      padding: '0px',
      height: '27px',
    },
    '&. MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: '0px',
    },
  },
  checkbox: {
    '& .MuiButtonBase-root': {
      background: 'none',
    },
  },
  tag: {
    margin: '3px 8px',
  },
  deleteIcon: {
    margin: '0px',
    cursor: 'pointer',
  },
  chipLabel: {
    padding: '6px 4px 5px 4px',
  },
  paper: {
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    borderRadius: '0 0 0.5rem 0.5rem',
    marginTop: '0.25rem',
    width: dropdownWidth ? dropdownWidth : 'auto',
  },
  customBox: {
    boxOrient: 'vertical',
    wordBreak: 'break-all',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '44px',
    width: '100%',
    backgroundColor: patientAccessTheme.palette.status.white,
    padding: '0px',
    margin: '0px',
  },
  icon: {
    height: '9.33px',
    color: patientAccessTheme.palette.text.mediumemphasis,
  },
  chipTypography: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
    color: patientAccessTheme.palette.chips.autoCompleteComponent,
    maxWidth: '60px',
    width: 'fit-content',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  selectFields: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.5rem',
    backgroundColor: patientAccessTheme.palette.status.white,
    height: '48px',
    overflow: 'hidden',
  },
  labelPrefix: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '24px',
    color: hasSelection
      ? '#000000'
      : patientAccessTheme.palette.text.mediumemphasis,
    marginRight: '4px',
    whiteSpace: 'nowrap',
  },
  inputWrapper: {
    position: 'relative',
    width: width ?? '300px',
  },
}));

const AutocompleteWithCheckBoxes = React.forwardRef<
  HTMLDivElement,
  AutocompleteWithCheckBoxesProps
>(
  (
    {
      options,
      handleChange,
      placeholder,
      defaultValue,
      width,
      onOpen,
       
      onScrollEvent,
      popupIcon,
      disabled,
      getOptionLabel,
      typable,
      limitTags,
      noOptionsText,
      disableClearAll = true,
      renderOption,
      dropdownWidth,
      fullWidthText,
      label,
    },
    ref,
  ) => {
    const hasSelection = defaultValue && defaultValue.length > 0;
    const { classes } = useStyles({ hasSelection, dropdownWidth, width });

    const [inputValue, setInputValue] = useState<string>('');

    const internalHandleInputChange = (
      event: React.ChangeEvent<HTMLInputElement>,
    ) => {
      setInputValue(event.target.value);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter' && inputValue && inputValue.trim()) {
        handleChange(
          null,
          defaultValue ? [...defaultValue, inputValue] : [inputValue],
          'createOption',
          null,
        );
        setInputValue('');
      }
    };

    return (
      <Box className={classes.inputWrapper}>
        <Autocomplete
          value={defaultValue}
          disabled={disabled}
          multiple
          limitTags={limitTags ?? 1}
          slots={{
            listbox: ListBox as React.ComponentType<
              React.HTMLAttributes<HTMLElement>
            >,
          }}
          id="checkboxes-tags-demo"
          options={options}
          onOpen={onOpen}
          onChange={(event: any, value: any, reason: any, details: any) => {
            handleChange(event, value, reason, details);
            setInputValue('');
          }}
          disableCloseOnSelect
          noOptionsText={noOptionsText ?? 'No Field found'}
          disableClearable={disableClearAll}
          getOptionLabel={(option: any) =>
            getOptionLabel ? getOptionLabel(option) : option?.name ?? option
          }
          renderValue={(tagValue: any, getItemProps: any) =>
            tagValue.map((option: any, index: number) => (
              <Chip
                {...getItemProps({ index })}
                label={
                  <Typography className={classes.chipTypography}>
                    {option?.name ?? option}
                  </Typography>
                }
                classes={{
                  deleteIcon: classes.deleteIcon,
                  label: classes.chipLabel,
                }}
                deleteIcon={<Close className={classes.icon} />}
                style={{
                  background: '#F7FAFF',
                  borderRadius: '4px',
                  border: '0.5px solid #727E9C',
                  padding: '5px 10px',
                  height: '22px',
                }}
              />
            ))
          }
          classes={{
            root: classes.autoCompleteDropdown,
            input: classes.autoCompleteInput,
            inputRoot: classes.autoCompleteInput,
            paper: classes.paper,
            tag: classes.tag,
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            if (option.id) {
              return option.id === value.id;
            } else {
              return option === value;
            }
          }}
          renderOption={
            renderOption ??
            ((props: any, option: any, { selected }: any) => {
              const { key, ...optionProps } = props;
              return (
                <Grid
                  component="li"
                  key={key}
                  {...optionProps}
                  className={classes.selectFields}
                >
                  <Checkbox
                    className={classes.checkbox}
                    color="primary"
                    checked={selected}
                    disableRipple={true}
                    style={{ pointerEvents: 'none' }}
                    icon={
                      <CheckBoxOutlineBlankOutlinedIcon
                        style={{
                          color: patientAccessTheme.palette.checkbox?.border1,
                        }}
                      />
                    }
                  />
                  <Typography
                    textColor={patientAccessTheme.palette.text.highemphasis}
                    fontSize="14px"
                    lineHeight="20px"
                    fontType="medium"
                  >
                    {fullWidthText
                      ? option?.name ?? option
                      : getTextWithToolTip(option?.name ?? option, 20)}
                  </Typography>
                </Grid>
              );
            })
          }
          style={{ width: width ?? '300px' }}
          renderInput={(params) =>
            typable ? (
              <TextField
                {...params}
                variant="outlined"
                placeholder={placeholder || ''}
                onChange={internalHandleInputChange}
                onKeyDown={handleKeyDown}
                value={inputValue}
                slotProps={{
                  ...params.slotProps,
                  input: {
                    ...params.slotProps.input,
                    startAdornment: (
                      <>
                        {label && (
                          <span className={classes.labelPrefix}>
                            {label} :-
                          </span>
                        )}
                        {params.slotProps.input.startAdornment}
                      </>
                    ),
                  },
                }}
              />
            ) : (
              <TextField
                {...params}
                variant="outlined"
                placeholder={placeholder || ''}
                slotProps={{
                  ...params.slotProps,
                  input: {
                    ...params.slotProps.input,
                    startAdornment: (
                      <>
                        {label && (
                          <span className={classes.labelPrefix}>
                            {label} :-
                          </span>
                        )}
                        {params.slotProps.input.startAdornment}
                      </>
                    ),
                  },
                }}
              />
            )
          }
          popupIcon={popupIcon}
          ref={ref}
        />
      </Box>
    );
  },
);

export default AutocompleteWithCheckBoxes;
